import { IClientConfigs } from '~/shared';
import { createSlice } from '../wrappers';

export type NumberPlatesRegion =
	IClientConfigs['vehicleNumberPlates']['regions'][number];

interface PlateBuyingSlice {
	tabIndex: number;
	maxTabIndex: number;
	plateInputFocus: boolean;
	region: NumberPlatesRegion | null;
	regionSelectVisible: boolean;
	number: string;
	regionCode: string;
	numberInput: string;
	classicNumberInput: string;
	customNumberInput: string;
	customNumber: string;
	selectedTypeIndex: number;
}

const initialState: PlateBuyingSlice = {
	tabIndex: 0,
	maxTabIndex: 1,
	plateInputFocus: false,
	region: null,
	regionSelectVisible: false,
	number: '',
	regionCode: '',
	numberInput: '',
	classicNumberInput: '',
	customNumberInput: '',
	customNumber: '',
	selectedTypeIndex: 0,
};

const plateBuyingSlice = createSlice({
	name: 'plateBuying',
	initialState,
	reducers: {
		setTabIndexPrev: (state) => {
			if (state.plateInputFocus) {
				return;
			}

			const index = state.tabIndex;
			state.tabIndex = index > 0 ? index - 1 : index;
		},
		setTabIndexNext: (state) => {
			if (state.plateInputFocus) {
				return;
			}

			const index = state.tabIndex;
			const maxIndex = state.maxTabIndex;
			state.tabIndex = index < maxIndex ? index + 1 : index;
		},
		setTabIndex: (state, action) => {
			state.tabIndex = action.payload;
		},
		setPlateInputFocus: (state, action) => {
			state.plateInputFocus = action.payload;
		},
		setRegion: (state, action) => {
			state.region = action.payload;
		},
		setRegionSelectVisible: (state, action) => {
			state.regionSelectVisible = action.payload;
		},
		setNumber: (state, action) => {
			state.number = action.payload;
		},
		setRegionCode: (state, action) => {
			state.regionCode = action.payload;
		},
		setNumberInput: (state, action) => {
			state.numberInput = action.payload;
		},
		setClassicNumberInput: (state, action) => {
			state.classicNumberInput = action.payload;
		},
		setCustomNumberInput: (state, action) => {
			state.customNumberInput = action.payload;
		},
		setCustomNumber: (state, action) => {
			state.customNumber = action.payload;
		},
		setSelectedTypeIndex: (state, action) => {
			state.selectedTypeIndex = action.payload;
		},
	},
});

export const {
	setTabIndexPrev,
	setTabIndexNext,
	setTabIndex,
	setPlateInputFocus,
	setRegion,
	setRegionSelectVisible,
	setNumber,
	setRegionCode,
	setNumberInput,
	setClassicNumberInput,
	setCustomNumberInput,
	setCustomNumber,
	setSelectedTypeIndex,
} = plateBuyingSlice.actions;

export default plateBuyingSlice.reducer;
